import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';

export const useWhatsAppMessageChannelFeature = () => {
  const isWhatsAppBetaEnabled = useFeatureFlag('WhatsAppMessageChannel', false);
  const isWhatsAppGAEnabled = useFeatureFlag('WhatsAppMessageChannelGA', false);
  return {
    /** `isWhatsAppEnabled` was originally used to control beta features. With the
     * GA release, customers who purchase the GA SKU will automatically get full
     * WhatsApp access without needing the beta flag. Beta users without the GA
     * SKU retain beta access, while a single GA flag now controls WhatsApp
     * availability per customer. */
    isWhatsAppEnabled: isWhatsAppBetaEnabled || isWhatsAppGAEnabled,
    /** Used to gate WhatsApp GA features. */
    isWhatsAppGAEnabled,
  };
};
